'use client';

import { type RefObject, useEffect, useState } from 'react';

interface UseContainerMeasurementReturn {
    containerWidth: number;
}

export function useContainerMeasurement(
    containerRef?: RefObject<HTMLDivElement | null>,
): UseContainerMeasurementReturn {
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        const measureWidth = (): void => {
            if (containerRef?.current) {
                setContainerWidth(containerRef.current.clientWidth);
            }
        };

        measureWidth();

        const resizeObserver = new ResizeObserver(measureWidth);
        if (containerRef?.current) {
            resizeObserver.observe(containerRef.current);
        }

        return () => resizeObserver.disconnect();
    }, [containerRef]);

    return { containerWidth };
}
